


import { IChangeTracking } from "../../../changeTracking/iChangeTracking";

import { RequestMaterials } from "./requestMaterials";
import { RequestPackages } from "./requestPackages";
import { RequestAssignedMaterialToPackage } from "./requestAssignedMaterialToPackage";
import { RequestAttachments } from "./requestAttachments";

export class RequestMaterial implements IChangeTracking {
   
    private _current: any;
    private _requestMaterials: RequestMaterials[] = [];
    private _requestPackages: RequestPackages[] = [];
    private _requestAssignedMaterialToPackage: RequestAssignedMaterialToPackage[] = [];
    private _requestAttachments: RequestAttachments[] = [];

    constructor(private _model: any) {

        this._current = this._model ? angular.copy(this._model) : {};
        this.loadRequestMaterials();
        this.loadRequestPackages();
        this.loadRequestAttachments();
        this.loadRequestAssignedMaterialToPackage();
    }


    
    private loadRequestMaterials(): void {

        if (this._current.requestMaterials !== undefined && this._current.requestMaterials.length > 0) {
            this._requestMaterials = [];
            for (let materials of this._current.requestMaterials) {
                this._requestMaterials.push(new RequestMaterials(materials));
            }
        }
    }

    private loadRequestPackages(): void {

        if (this._current.requestPackages !== undefined && this._current.requestPackages.length > 0) {
            this._requestPackages = [];
            for (let packages of this._current.requestPackages) {
                this._requestPackages.push(new RequestPackages(packages));
            }
        }
    }

    private loadRequestAttachments(): void {

        if (this._current.requestAttachments !== undefined && this._current.requestAttachments.length > 0) {
            this._requestAttachments = [];
            for (let attachments of this._current.requestAttachments) {
                this._requestAttachments.push(new RequestAttachments(attachments));
            }
        }
    }

    private loadRequestAssignedMaterialToPackage(): void {

        if (this._current.requestAssignedMaterialToPackage !== undefined && this._current.requestAssignedMaterialToPackage.length > 0) {
            this._requestAssignedMaterialToPackage = [];
            for (let rqAssignedMaterialToPackage of this._current.requestAssignedMaterialToPackage) {
                this._requestAssignedMaterialToPackage.push(new RequestAssignedMaterialToPackage(rqAssignedMaterialToPackage));
            }
        }
    }


    get requestMaterials(): RequestMaterials[] {
       return this._requestMaterials;
    }

    set requestMaterials(val: RequestMaterials[]) {
        
        this._requestMaterials = [];
        for (let mtrl of val) {
            this._requestMaterials.push(new RequestMaterials(mtrl));
        }
    }
    
    get requestPackages(): RequestPackages[] {
        return this._requestPackages;
    }

    set requestPackages(val: RequestPackages[]) {
        this._requestPackages = [];
        for (let pkg of val) {
            this._requestPackages.push(new RequestPackages(pkg));
        }
    }

    get requestAssignedMaterialToPackage(): RequestAssignedMaterialToPackage[] {
        return this._requestAssignedMaterialToPackage;
    }

    set requestAssignedMaterialToPackage(val: RequestAssignedMaterialToPackage[]) {
        this._requestAssignedMaterialToPackage = [];
        for (let rqAssignMaterialsTopkg of val) {
            this._requestAssignedMaterialToPackage.push(new RequestAssignedMaterialToPackage(rqAssignMaterialsTopkg));
        }
    }

    get requestAttachments(): RequestAttachments[] {
        return this._requestAttachments;
    }

    set requestAttachments(val: RequestAttachments[]) {
        this._requestAttachments = [];
        for (let attachment of val) {
            this._requestAttachments.push(new RequestAttachments(attachment));
        }
    }

    hasChanges(): boolean {
        return !angular.equals(this._current, this._model);
    }

    revert(): void {
        this._current = angular.copy(this._model);
    }

    commit(): void {
        this._model = angular.copy(this._current);
    }

    toJson(): any {
        return this._current;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/models/requestMaterial.ts
 **/